import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Outlet, useNavigate } from "react-router-dom";
import { selectToken } from "../../redux/auth/authSlice";
import { getAdminById, selectAdmin } from "../../redux/admin/adminSlice";

function AuthLayout() {
  const token = useSelector(selectToken);
  const admin = useSelector(selectAdmin);
  // const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAdminById());
    if (token) {
      if (admin?.role === "employee") {
        console.log("Navigating to employee");
        navigate("/employee");
      } else if (admin?.role === "supervisor") {
        console.log("Navigating to dashboard");
        navigate("/dashboard/companies");
      } else if (admin?.role === "administrator") {
        console.log("Navigating to dashboard");
        navigate("/dashboard/companies");
      }
    }
  }, [token, admin, navigate, dispatch]);

  return (
    <div className="">
      <div className="">
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
